import { render, staticRenderFns } from "./commonQRCode.vue?vue&type=template&id=8b7f01fe&scoped=true"
import script from "./commonQRCode.vue?vue&type=script&lang=js"
export * from "./commonQRCode.vue?vue&type=script&lang=js"
import style0 from "./commonQRCode.vue?vue&type=style&index=0&id=8b7f01fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7f01fe",
  null
  
)

export default component.exports